import { IntegrationsChooseSoftwareStep } from './choose-software/integrations-choose-software';
import { IntegrationsConnectionPreviewStep } from './connection-preview/integrations-connection-preview';
import { IntegrationsImportPreviewStep } from './import-preview/integrations-import-preview';
import { IntegrationsSummaryStep } from './summary/integrations-summary';

export default [
    IntegrationsChooseSoftwareStep,
    IntegrationsConnectionPreviewStep,
    IntegrationsImportPreviewStep,
    IntegrationsSummaryStep,
];
